import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MeasureModule} from '../../../../models/measure/measure-module';
import {CommonConstant, measureModuleIconPath} from '../../../app.constants';
import {DropEvent} from 'ng-drag-drop';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'measure-modules-selection',
  templateUrl: './measure-modules-selection.component.html',
  styleUrls: ['./measure-modules-selection.component.scss']
})
export class MeasureModulesSelectionComponent {

  @Input()
  module: MeasureModule = new MeasureModule();

  @Input()
  index: number;
  @Input()
  public measureActionContext;
  @Input()
  public canEditable;

  @Output()
  afterDropCallback: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  activeCallback: EventEmitter<any> = new EventEmitter<any>();

  public isActivated = true;

  constructor(private userService: UserService) {
  }


  get iconPath() {
    if (!this.module) {
      return '';
    }
    const keyIcon = Object.keys(measureModuleIconPath).find(
      (key) => this.module.id === measureModuleIconPath[key].id
    );
    return keyIcon && this.module.isActive ? measureModuleIconPath[keyIcon].path : measureModuleIconPath[keyIcon].inactivePath;
  }

  get checkmarkIcon() {
    return this.module.isActive ? 'assets/images/Check_Green.svg' : 'assets/images/Check_Dark.svg';
  }

  get dropData() {
    return {
      index: this.index,
      module: this.module,
    };
  }

  get moduleName() {
    if (!this.module) {
      return '';
    }
    return this.module.name;
  }


  onAnyDrop(e: DropEvent) {
    if (!this.isFreeUser && this.canEditable) {
      this.afterDropCallback.emit({
        draggedModuleIndex: e.dragData.index,
        droppedModuleIndex: this.index,
        draggedModule: e.dragData.module,
        droppedModule: this.module
      });
    }
  }

  onActivatedModule(moduleId) {
    if (!this.isFreeUser && this.canEditable) {
      this.isActivated = true;
      this.activeCallback.emit(moduleId);
    }
  }

  get isFreeUser() {
    return this.userService.isFreeUser();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-modules-selection/measure-modules-selection.component.ts